const pageHeader = document.querySelector(".page-header");
const toggleMenu = pageHeader.querySelector(".toggle-menu");
const menuWrapper = pageHeader.querySelector(".menu-wrapper");
const level1Links = pageHeader.querySelectorAll(".level-1 > li > a");
const listWrapper2 = pageHeader.querySelector(".list-wrapper:nth-child(2)");
const listWrapper3 = pageHeader.querySelector(".list-wrapper:nth-child(3)");
const subMenuWrapper2 = listWrapper2.querySelector(".sub-menu-wrapper");
const subMenuWrapper3 = listWrapper3.querySelector(".sub-menu-wrapper");
const backOneLevelBtns = pageHeader.querySelectorAll(".back-one-level");
const isVisibleClass = "is-visible";
const isActiveClass = "is-active";
const closeBtn = document.querySelector("button.close-btn-menu");
const closeBtn2 = document.querySelector("button.close-btn-menu-2");
const headerDarkBackground = document.querySelector("div.header-dark-background");



toggleMenu.addEventListener("click", function () {
  console.log("esta a dar");
      //headerDarkBackground.classList.add("visible");
  menuWrapper.classList.toggle(isVisibleClass);
  
  if (!this.classList.contains(isVisibleClass)) {
    listWrapper2.classList.remove(isVisibleClass);
    listWrapper3.classList.remove(isVisibleClass);
    const menuLinks = menuWrapper.querySelectorAll("a");
    for (const menuLink of menuLinks) {
      menuLink.classList.remove(isActiveClass);
    }
  }
});

for (const level1Link of level1Links) {
  level1Link.addEventListener("click", function (e) {
    // Check if this link should navigate directly (not open submenu)
    const isDirectLink = this.getAttribute('data-direct-link') === 'true';
    console.log('Mobile menu clicked:', this.textContent.trim(), 'data-direct-link:', this.getAttribute('data-direct-link'), 'isDirectLink:', isDirectLink);

    if (isDirectLink) {
      // Let the link navigate normally
      console.log('Direct link detected - allowing navigation');
      return;
    }

    const siblingList = this.nextElementSibling;
    if (siblingList) {
      e.preventDefault();
      this.classList.add(isActiveClass);
      const cloneSiblingList = siblingList.cloneNode(true);
      subMenuWrapper2.innerHTML = "";
      subMenuWrapper2.append(cloneSiblingList);
      listWrapper2.classList.add(isVisibleClass);
         headerDarkBackground.classList.remove("visible");
    }
  });
}

listWrapper2.addEventListener("click", function (e) {
  const target = e.target;
  if (target.tagName.toLowerCase() === "a" && target.nextElementSibling) {
    const siblingList = target.nextElementSibling;
    e.preventDefault();
    target.classList.add(isActiveClass);
    const cloneSiblingList = siblingList.cloneNode(true);
    subMenuWrapper3.innerHTML = "";
    subMenuWrapper3.append(cloneSiblingList);
    listWrapper3.classList.add(isVisibleClass);
  }
});

for (const backOneLevelBtn of backOneLevelBtns) {
  backOneLevelBtn.addEventListener("click", function () {
    const parent = this.closest(".list-wrapper");
    parent.classList.remove(isVisibleClass);
    parent.previousElementSibling
      .querySelector(".is-active")
      .classList.remove(isActiveClass);
  });
}

closeBtn.addEventListener("click", function () {
  menuWrapper.classList.toggle(isVisibleClass);
    headerDarkBackground.classList.remove("visible");
  if (!this.classList.contains(isVisibleClass)) {
    listWrapper2.classList.remove(isVisibleClass);
    listWrapper3.classList.remove(isVisibleClass);
    const menuLinks = menuWrapper.querySelectorAll("a");
    for (const menuLink of menuLinks) {
      menuLink.classList.remove(isActiveClass);
    }
  }
});

closeBtn2.addEventListener("click", function () {
  menuWrapper.classList.toggle(isVisibleClass);
  if (!this.classList.contains(isVisibleClass)) {
    listWrapper2.classList.remove(isVisibleClass);
    listWrapper3.classList.remove(isVisibleClass);
    const menuLinks = menuWrapper.querySelectorAll("a");
    for (const menuLink of menuLinks) {
      menuLink.classList.remove(isActiveClass);
    }
  }
});


// Open header nav on large screens

const navTab = document.querySelectorAll('.dropdown-btn');
const dropDownMenu = document.querySelectorAll('.dropdown-content');
//const headerDarkBackground = document.querySelector("div.header-dark-background");


for (const link of navTab) {
  link.addEventListener("click", function (e) {
    const siblingList = link.nextElementSibling;

    // Check if this menu item should navigate directly
    const directLinkAttr = link.getAttribute('data-direct-link');
    const isDirectLink = directLinkAttr === 'true';

    console.log('Menu clicked:', link.textContent.trim(), 'data-direct-link:', directLinkAttr, 'isDirectLink:', isDirectLink);

    if (isDirectLink) {
      e.preventDefault();
      const url = link.getAttribute('data-href');
      if (url) {
        window.location.href = url;
        return;
      }
    }

    for (const dropDown of dropDownMenu) {
      dropDown.classList.remove("show");
    }

  if (siblingList) {
    e.preventDefault();
    siblingList.classList.toggle("show");
    headerDarkBackground.classList.add("visible");
    console.log(link);
  }

  headerDarkBackground.addEventListener("click", function() {
    console.log('Estou a clicar no dark background')
    siblingList.classList.remove("show");
    headerDarkBackground.classList.remove("visible");
  })
})
}

